var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcRejectionOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 4,
    fill: "#28323C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2099 15.326C23.068 16.9475 22.4915 18.4928 21.5478 19.7811C20.6042 21.0694 19.3325 22.0474 17.8815 22.6006C16.4305 23.1538 14.8603 23.2594 13.3546 22.905C11.8488 22.5506 10.4698 21.7509 9.37894 20.5994C8.28807 19.4479 7.53043 17.9923 7.19468 16.4029C6.85894 14.8135 6.95897 13.156 7.48307 11.6245C8.00717 10.0929 8.93367 8.75052 10.1541 7.75446C11.3746 6.75841 12.8386 6.14985 14.3748 6C13.4754 7.28436 13.0426 8.86681 13.1551 10.4595C13.2677 12.0523 13.918 13.5494 14.9879 14.6788C16.0578 15.8081 17.4762 16.4946 18.9851 16.6134C20.494 16.7322 21.9932 16.2753 23.2099 15.326Z",
    fill: "#14F1FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRejectionOn);
export default __webpack_public_path__ + "static/media/ic_rejection_on.5d7a0649873ac95368045f6e00286f7e.svg";
export { ForwardRef as ReactComponent };